module.exports = __webpack_public_path__ + "static/img/C1.93edc9b9.jpg";